import { webApi } from '@lib/api'

export const checkVersion = () => webApi({ self: true }).get('/version.rc')
